import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  translations: string[] = [];

  constructor() {
    this.translations['course'] = 'Lehrgang';
    this.translations['competition'] = 'Wettkampf';

    this.translations['checked'] = 'Überprüft';
    this.translations['draft'] = 'Entwurf';
    this.translations['reviewed'] = 'Korrektur';
    this.translations['published'] = 'Freigabe';
    this.translations['rejected'] = 'Abgelehnt';
    this.translations['printed'] = 'im Druck';

    this.translations['check'] = 'überprüfen';
    this.translations['publish'] = 'freigeben';
    this.translations['rework'] = 'überarbeiten';
    this.translations['review'] = 'geprüft durch FB';
    this.translations['reject'] = 'ablehnen';
    this.translations['print'] = 'drucken';
    this.translations['update'] = 'ergänzen';
  }

  transform(value: string): string {
    if (value in this.translations) {
      return this.translations[value];
    }
    return value;
  }

}
